export default "__VITE_ASSET__CUoqtNHv__"